module.exports = __webpack_public_path__ + "img/eoc-four-points-office-building-3.12145cf7.jpg";